import container from '../../container';
import { useSelectedShopId } from '../../hooks/useSelectedShop';
import { useQuery } from '@tanstack/react-query';

function useClaimsCounts() {
  const shopId = useSelectedShopId();

  const { isLoading, data } = useQuery({
    queryKey: ['shopClaimsCounts', shopId],
    queryFn: () => container.touchpointsApi.getClaimsCounts(shopId),
  });

  return {
    isLoading,
    claimsCounts: data,
  };
}

export default useClaimsCounts;
